import request from '@/utils/request'

/*
 * 获取多条分类信息信息
 * @param params
 * @return promise对象
 */
export function PRO_CATS_GET(params) {
  return request({
    url: `/pub/mall/pro_cat`,
    method: 'get',
    params
  })
}

/*
 * 获取单条分类
 * @param params
 * @return promise对象
 */
export function PRO_CAT_GET(id, params) {
  return request({
    url: `/pub/mall/pro_cat/${id}`,
    method: 'get',
    params
  })
}

/*
 * 获取搜索时相关产品分类
 * @param params
 * @return promise对象
 */
export function PRO_CAT_SEARCHTO(params) {
  return request({
    url: `/pub/mall/pro_cat/searchto`,
    method: 'get',
    params
  })
}

// MODEL 定义的变量
export const VARS = {
  // 用户类型
  // {
  //   value: '1',
  //   label: '普通'
  // },
}



// WEBPACK FOOTER //
// ./src/api/mall/pro_cat.js